import { render, staticRenderFns } from "./productBinding.vue?vue&type=template&id=acf65192&scoped=true&"
import script from "./productBinding.vue?vue&type=script&lang=js&"
export * from "./productBinding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf65192",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acf65192')) {
      api.createRecord('acf65192', component.options)
    } else {
      api.reload('acf65192', component.options)
    }
    module.hot.accept("./productBinding.vue?vue&type=template&id=acf65192&scoped=true&", function () {
      api.rerender('acf65192', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/backhaul/components/productBinding.vue"
export default component.exports